<!--  -->
<template>
  <div class="main">
    <div class="scale_box" :style="{ transform: `scale(${scale})` }">
      <div class="title"></div>
      <div class="top">
        <div class="rank1"></div>
        <div class="rank2"></div>
        <div class="rank3"></div>
        <div class="rank_inner1">
          <div class="rank_line1 grace-space-around-center" v-if="NO1.user">
            <div class="rank_name">{{NO1.user.name}}</div>
            <div class="rank_score">{{parseInt(NO1.score || 0)}}<span class="fen">分</span></div>
          </div>
          <div class="rank_line2 grace-space-around-center">
            <div class="lilun">理论 {{NO1.lilun_score || 0}}</div>
            <div class="vr">VR {{parseInt(NO1.vr_score || 0)}}</div>
          </div>
        </div>
        <div class="rank_inner2">
          <div class="rank_line1 grace-space-around-center" v-if="NO2.user">
            <div class="rank_name">{{NO2.user.name}}</div>
            <div class="rank_score">{{parseInt(NO2.score || 0)}}<span class="fen">分</span></div>
          </div>
          <div class="rank_line2 grace-space-around-center">
            <div class="lilun">理论 {{NO2.lilun_score || 0}}</div>
            <div class="vr">VR {{parseInt(NO2.vr_score || 0)}}</div>
          </div>
        </div>
        <div class="rank_inner3">
          <div class="rank_line1 grace-space-around-center" v-if="NO3.user">
            <div class="rank_name">{{NO3.user.name}}</div>
            <div class="rank_score">{{parseInt(NO3.score || 0)}}<span class="fen">分</span></div>
          </div>
          <div class="rank_line2 grace-space-around-center">
            <div class="lilun">理论 {{NO3.lilun_score || 0}}</div>
            <div class="vr">VR {{parseInt(NO3.vr_score || 0)}}</div>
          </div>
        </div>
      </div>
      <div class="line2 grace-space-around-center">
        <div class="my_num desc">NO.{{myScore.rank}}</div>
        <div class="my_title desc">我的排名</div>
        <div style="width: 83px;" class="my_lilun desc">理论 {{myScore.lilun_score || 0}}</div>
        <div class="my_vr desc">VR {{parseInt(myScore.vr_score || 0)}}</div>
        <div class="my_score desc">{{parseInt(myScore.score || 0)}} <span class="fen">分</span></div>
      </div>
      <div class="line"></div>
<!--      <div class="rank_box" v-if="phInfo.length>3">-->
        <div class="rank_box">
        <div class="rank_item grace-space-around-center" v-if="phInfo.length>3" v-for="(item,index) in phInfo" :key="index">

          <div class="rank_item_num desc">NO.{{index+1}}</div>
          <div class="rank_item_title desc">{{item.user.name}}</div>
          <div style="width: 83px;" class="rank_item_lilun desc">理论 {{item.lilun_score || 0}}</div>
          <div class="rank_item_vr desc">VR {{parseInt(item.vr_score || 0)}}</div>
          <div class="rank_item_score desc">{{parseInt(item.score || 0)}} <span class="fen">分</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      initHeight: 976,
      scale: 1,
      height: 976,
    };
  },

  components: {},

  computed: {
    ...mapGetters({
      dataList: "rank/examList",
      phInfo: "rank/phInfo",
      myScore: "rank/myScore",
      isPC: "rank/isPC",
    }),
    NO1(){
      if(this.phInfo[0]){
        return this.phInfo[0]
      }else{
        return {}
      }
    },
    NO2(){
      if(this.phInfo[1]){
        return this.phInfo[1]
      }else{
        return {}
      }
    },
    NO3(){
      if(this.phInfo[2]){
        return this.phInfo[2]
      }else{
        return {}
      }
    },
  },

  mounted() {
    let user_id = this.$route.query.user_id;
    window.addEventListener("resize", this.initSize);
    setTimeout(() => {
      this.initSize();
    }, 0);
    let shijuan_id;
    if(this.dataList.shijuan_id){
      shijuan_id = this.dataList.shijuan_id
      window.sessionStorage.setItem('shijuan_id',shijuan_id)
    }else{
      shijuan_id = window.sessionStorage.getItem('shijuan_id')
    }
    let param = {
      shijuan_id: shijuan_id,
      action: 3,
      user_id:user_id
    };
    this.getphInfo(param).then(() => {
      console.log("this.phInfo",this.phInfo);
    });
  },

  methods: {
    ...mapActions({
      getphInfo: "rank/getphInfo",
    }),
    initSize() {
      if(!this.isPC){
        return this.scale = 0.9;
      }
      let clientHeight = this.getClientHeight();
      if (clientHeight > 1080) {
        this.scale = 1080 / this.initHeight;
        this.height = 1080;
      } else if (clientHeight > 680) {
        this.scale = clientHeight / this.initHeight;
        this.height = clientHeight;
      } else {
        this.scale = 680 / this.initHeight;
        this.height = 680;
      }
      console.log(this.scale);
    },
    getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        var clientHeight =
          document.body.clientHeight < document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight;
      } else {
        var clientHeight =
          document.body.clientHeight > document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight;
      }
      return clientHeight;
    },
  },
};
</script>
<style scoped lang="scss">
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/Rank/index.vue